module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/boxoffice/boxoffice.component.scss
// module id = ./src/app/routes/boxoffice/boxoffice.component.scss
// module chunks = 9